<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <label *ngIf="page.webpage_heading > ''" class="checklist-h1 col-xs-12">{{ page.webpage_heading | uppercase }}</label>
        <tt-select ttLabel="resource_name_superior" [ttModel]="page.resource_id_superior" (ttModelChange)="onSuperiorChanged($event)" [ttData]="superiors" ttDataId="resource_id" ttDataName="resource_name"></tt-select>
        <tt-datetime ttLabel="first_alert_dt" [ttModel]="page.first_alert_dt" (ttModelChange)="onAlertDateChanged($event)" [ttMinutePrecision]="1"></tt-datetime>
        <tt-input ttLabel="filtervalue" [(ttModel)]="page.filtervalue" ttShowClearButton></tt-input>
        <tt-button-save ttText="sroperationar_add" [ttLoading]="saving" (ttClick)="saveChanges()"></tt-button-save>
        <tt-list [ttData]="resources | filterList : page.filtervalue" [ttGoto]="false" (ttClick)="toggleChosen($event.item)">
            <ng-template #ttListItemTemplate let-item="item">
                <button type="button" class="tt-list-item__button" (click)="toggleChosen(item)">
                    <span *ngIf="item.item_id !== '0' && item.item_id !== '-1'" class="fas" [class.fa-check-square]="item.item_is_selected === '1'" [class.fa-square]="item.item_is_selected !== '1'" aria-hidden="true"></span>
                    <span>{{ item.item_name }}</span>
                    <div>{{ item.item_name_sub1 }}</div>
                    <div>{{ item.item_name_sub2 }}</div>
                </button>
            </ng-template>
        </tt-list>
    </tt-card>
</tt-page>
